import "../../style/mobile/azmoon-list/M_ExamsList.scss";
import icon1 from "../../../assets/mobile/azmoon-list/vuesax-linear-task-square.svg";
import MHSearch from "../home/MH_Search";
import { useState } from "react";
import MCurrentExams from "./M_CurrentExams";
import MPastExams from "./M_PastExams";

const M_ExamsList = () => {
  const [activeTab, setActiveTab] = useState("A");

  const chooseTabA = () => {
    setActiveTab("A");
    document.querySelector(".M_ExamsList-tabs-bg").style.right = "0px";
  };
  const chooseTabB = () => {
    setActiveTab("B");
    document.querySelector(".M_ExamsList-tabs-bg").style.right = "50%";
  };
  return (
    <div className="M_ExamsList">
      <div className="M_ExamsList-title-box">
        <img
          src={icon1}
          alt="exam-list-icon"
          className="M_ExamsList-title-box-icon"
        />
        <div className="M_ExamsList-title-box-text">لیست آزمون‌ها</div>
      </div>
      <MHSearch />
      <div className="M_ExamsList-tabs">
        <div className="M_ExamsList-tabs-bg"></div>
        <div
          style={activeTab === "A" ? { color: "#FFF" } : null}
          className="M_ExamsList-tabs-item"
          onClick={chooseTabA}
        >
          آزمون‌های پیش‌رو
        </div>
        <div
          style={activeTab === "B" ? { color: "#FFF" } : null}
          className="M_ExamsList-tabs-item"
          onClick={chooseTabB}
        >
          آزمون‌های گذشته
        </div>
      </div>
      {activeTab === "A" && <MCurrentExams />}
      {activeTab === "B" && <MPastExams />}
    </div>
  );
};

export default M_ExamsList;
